import './style.css'
import React from "react";
function Address() {
  return (
    <section className="address-section">
      <div className="container">
        <h6 style={{fontSize: 15 }}>© MAXCODE IT SOLUTIONS PVT LTD 2025. <span style={{ paddingLeft:  '5px', fontWeight: 400, color: '#white'}}> All rights reserved.</span></h6>
      </div>
    </section>
  );
}

export default Address;